export * from "./widget-config-page.view";
export * from "./widget-text-config-page";
